import React from 'react';
import { Paragraph, Strong } from '../../theme';
import { Dialog, DialogContent, DialogContentText } from '@mui/material';
import HMOCardImage from '../../assets/images/HMOInsuranceCard.png';
import { ModalProps } from '../../utils/types';
import { isMobile } from 'react-device-detect';
import CloseIcon from './CloseIcon';

const NotSureMedicalGroupModal = ({ open, handleClose }:ModalProps): JSX.Element => {
    return (
        <Dialog
            maxWidth='md'
            fullWidth={true}
            open={open}
            onClose={handleClose}
        >
            <DialogContent sx={{ padding: '35px' }}>
                <CloseIcon handleClose={handleClose}/>
                <DialogContentText>
                    <Paragraph><Strong>Not seeing your medical group?</Strong></Paragraph>
                    <Paragraph style={{ textAlign: isMobile ? 'left' : 'center' }}>Check out this example card and look at your own for the following</Paragraph>
                    <img src={HMOCardImage} style={{ width: '100%', maxWidth: '500px', margin: '0 auto', display: 'flex' }}/>
                    <Paragraph style={{}}>
                        <ul style={{ paddingLeft: '20px' }}>
                            <li>Check your insurance card to confirm the correct medical group</li>
                            <li>Make sure the medical group is spelled correctly</li>
                            <li>Call us at 1.858.554.1212 so our staff can help</li>
                        </ul>
                    </Paragraph>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default NotSureMedicalGroupModal;
